import { pieChartConfig } from './pieChartConfig.js';
import { scatterChartConfig } from './scatterChartConfig.js';

// 基礎圖表配置
export const chartBaseConfig = {
    // 圖例
	legend: {
		show: true,
		type: "plain",
		orient: "horizontal",
		top: 20,
		left: "center",
		textStyle: {
			fontSize: 12,
			color: "#fff",
		},
		formatter: name => name,
	},
	
    // 提示框
	tooltip: { 
		trigger: "item",
	},
};

// 處理圓餅圖數據
export const processPieChartData = (ageGroupData, selectedAges, hasAgeFilter, getAgeRangeDisplayName) => {
	if (!ageGroupData || ageGroupData.length === 0) {
		return pieChartConfig.defaultData;
	}

	let pieData = [];

	if (hasAgeFilter && selectedAges.length > 0) {
		// 有年齡篩選時
		pieData = ageGroupData
			.filter(item => {
				const ageGroupKey = item.AgeGroup;
				return selectedAges.includes(ageGroupKey);
			})
			.map((item, index) => {
				const ageGroupKey = item.AgeGroup;
				const ageRangeInfo = getAgeRangeDisplayName(ageGroupKey);
				return {
					name: ageRangeInfo.label,
					value: item.Count,
					totalCount: item.TotalCount,
					itemStyle: {
						color: ageRangeInfo.color,
						...pieChartConfig.ageRangeStyles.selected,
					},
				};
			});
	} else {
		// 無年齡篩選時
		pieData = ageGroupData.map((item, index) => {
			const ageGroupKey = item.AgeGroup;
			const ageRangeInfo = getAgeRangeDisplayName(ageGroupKey);
			return {
				name: ageRangeInfo.label,
				value: item.Count,
				totalCount: item.TotalCount,
				itemStyle: {
					color: ageRangeInfo.color,
					...pieChartConfig.ageRangeStyles.default,
				},
			};
		});
	}

	return pieData.length > 0 ? pieData : pieChartConfig.defaultData;
};

// 處理散布圖數據
export const processScatterChartData = (transformedData, ageRangeMap, getAgeRangeDisplayName, generateTooltipHTML) => {
	if (!transformedData || !transformedData.data || transformedData.data.length === 0) {
		return [];
	}

	const scatterData = {};
	transformedData.data.forEach(item => {
		const ageRange = item.ageRange;
		if (!scatterData[ageRange]) {
			scatterData[ageRange] = [];
		}
		scatterData[ageRange].push(item);
	});

	// 按年齡範圍排序
	const sortedAgeRanges = Object.keys(scatterData).sort((a, b) => {
		const indexA = ageRangeMap.findIndex(item => item.key === a);
		const indexB = ageRangeMap.findIndex(item => item.key === b);
		return indexA - indexB;
	});

	return sortedAgeRanges.map(ageRange => {
		const ageRangeInfo = getAgeRangeDisplayName(ageRange);
		return {
			...scatterChartConfig.basic,
			name: ageRangeInfo.label,
			data: scatterData[ageRange],
			itemStyle: {
				color: ageRangeInfo.color,
				borderColor: ageRangeInfo.color,
				...scatterChartConfig.itemStyle,
			},
			emphasis: {
				itemStyle: {
					color: ageRangeInfo.color,
					borderColor: ageRangeInfo.color,
					...scatterChartConfig.emphasis.itemStyle,
				},
			},
			tooltip: {
				...scatterChartConfig.tooltip,
				formatter: function (params) {
					const sourceData = params.data;
					return generateTooltipHTML(params, sourceData, ageRangeInfo.color);
				},
			},
		};
	});
};

// 創建圖表選項
export const createChartOption = (baseOption, selectedType, pieData, scatterSeries, generateSimpleTooltipHTML) => {
	const axisLabelFormatters = scatterChartConfig.axisLabelFormatters;

	return {
		...baseOption,
		grid: scatterChartConfig.grid,
		xAxis: {
			...scatterChartConfig.axis.xAxis,
			axisLabel: {
				formatter: (value) => axisLabelFormatters.xAxis(value, selectedType),
			},
		},
		yAxis: {
			...scatterChartConfig.axis.yAxis,
			axisLabel: {
				formatter: axisLabelFormatters.yAxis,
			},
		},
		series: [
			// 圓餅圖
			{
				...pieChartConfig.basic,
				data: pieData,
				label: pieChartConfig.label,
				labelLine: pieChartConfig.labelLine,
				tooltip: {
					...pieChartConfig.tooltip,
					formatter: function (params) {
						const pieItem = pieData.find(item => item.name === params.name);
						const sourceData = {
							age: params.name,
							percent: `${params.percent}%`,
							count: `${params.value} 人`,
							totalCount: `${pieItem?.totalCount || 0} 人`,
						};
						return generateSimpleTooltipHTML(params, sourceData, params.color);
					},
				},
				emphasis: pieChartConfig.emphasis,
			},
			// 散布圖系列
			...scatterSeries,
		],
	};
};
